export const CONFIG_APARENCIA = 'CONFIG_APARENCIA';
export const CONFIG_APARENCIA_START = 'CONFIG_APARENCIA_START';
export const CONFIG_APARENCIA_SUCCESS = 'CONFIG_APARENCIA_SUCCESS';
export const CONFIG_APARENCIA_ERROR = 'CONFIG_APARENCIA_ERROR';
